import { IOfferMode } from "@nju/data-access-portal-offers";
import {
  IFtthOrchestrator,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { orderStatusInProgress } from "@nju/data-access-portal-order";
import { IRegistrationDocumentType } from "@nju/data-access-portal-user";

interface ISetOrderId {
  mode: IOfferMode | undefined;
  ftth: IFtthOrchestrator | undefined;
  multiOrder: IMultiOrderOrchestrator | undefined;
}

export function setOrderId({ mode, ftth, multiOrder }: ISetOrderId) {
  let orderId: string | undefined;

  if (mode === "ftth" && ftth) {
    orderId = ftth.orderId;
  } else if (
    mode === "mobile" &&
    multiOrder &&
    multiOrder.multiOrderItems &&
    multiOrder.multiOrderItems.length === 1
  ) {
    orderId = multiOrder.multiOrderItems[0].orderId;
  } else if (!mode) {
    if (orderStatusInProgress(ftth)) {
      orderId = ftth?.orderId;
    } else if (orderStatusInProgress(multiOrder)) {
      orderId = undefined;
    }
  }

  return orderId;
}

const documentsName: Record<IRegistrationDocumentType, string> = {
  PESEL: "pesel",
  PASSPORT: "paszport",
  RESIDENCEPERMIT: "karta pobytu",
  NATIONALIDCARD: "dowód osobisty",
  IDCARD: "dowód osobisty",
};

export function getDocumentName(document: IRegistrationDocumentType) {
  return documentsName[document];
}
